export default __webpack_public_path__ + "static/media/white_logo.7ca55d5b.png";